<template>
  <div class="home">
    <b-container class="bv-example-row">
      <b-row>
        <b-col class="p-0 menu">
          <Menu />
        </b-col cols="12" md="auto">
        <b-col>
          <Header />

          <b-container class="dashboard-content">

            Only users added to this table will be able to register for an account.<br />

            <Spinner v-show="showSpinner" /><br />

            <b-table-simple hover small responsive borderless>
              <b-thead class="bg-dkblue text-white">
                <b-tr>
                  <b-th>E-mail Address</b-th>
                  <b-th>Whitelisted</b-th>
                  <b-th>Registered</b-th>
                  <b-th></b-th>
                </b-tr>
              </b-thead>
              <b-tbody>
                <b-tr class="table-row">
                  <b-th><b-form-input v-model="newWhitelistUser" class="table-input" type="email" placeholder="Add a new e-mail address"></b-form-input></b-th>
                  <b-td></b-td>
                  <b-td></b-td>
                  <b-td class="button-cell"><b-link @click=""><b-icon @click="addWhitelistUser()" icon="plus-square"></b-icon></b-link></b-td>
                </b-tr>
              </b-tbody>
              <b-tbody v-for="result in results">
                <b-tr class="table-row">
                  <b-th>{{ result.email }}</b-th>
                  <b-td>{{ result.created }}</b-td>
                  <b-td>{{ result.used }}</b-td>
                  <b-td class="button-cell"><b-link @click="confirmDelete(result.email)"><b-icon @click="" icon="x-square"></b-icon></b-link></b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>

          </b-container>

        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
// @ is an alias to /src
import Menu from '@/components/Menu.vue'
import Header from '@/components/Header.vue'
import Spinner from '@/components/Spinner.vue'
const axios = require('axios')

export default {
  name: 'dashboard', 
  data(){
    return {
        showSpinner: false,
        newWhitelistUser: null,
        results: []
      }
  },
  mounted() {
    this.showSpinner = true,
    this.$store.state.page = "User Whitelist"
    this.getUserWhitelist()





  },
  computed: {
    user () {
      return this.$store.state.user
      // { "logged": true, "loggedInAs": { "name": "Alok Wadhwani", "email": "alok@alokw.com" } }
    },
  },
  components: {
    Menu,
    Header,
    Spinner
  },
  methods: {

    testPopup() {
      alert('test popup')
    },

    getUserWhitelist() {
      this.results = []
      var url = this.$store.state.locals.apiUrl + '/getUserWhitelist'
      var config = {
        method: 'get',
        url: url,
        headers: { 
          'api-key': this.$apikey, 
          'Content-Type': 'application/json'
        }
      };

      axios(config)
      .then((response) => {
        //this.results = response.data,
        this.parseWhitelist(response.data),
        this.showSpinner = false

      })
      .catch((error) => {
        console.log(error);
        this.$store.state.error = error;
        this.$router.push('dashboard_error')
      });
    },

    addWhitelistUser() {
      this.showSpinner = true

      var email = this.newWhitelistUser.toLowerCase()
      var data = { "email": email }
      var url = this.$store.state.locals.apiUrl + '/addWhitelistUser'
      var config = {
        method: 'put',
        url: url,
        headers: { 
          'api-key': this.$apikey, 
          'Content-Type': 'application/json'
        },
        data : data
      };

      axios(config)
      .then((response) => {
        this.getUserWhitelist()
        this.showSpinner = false

      })
      .catch((error) => {
        console.log(error);
        this.$store.state.error = error;
        this.$router.push('dashboard_error')
      });




    },


    deleteWhitelistUser(email) {
      this.showSpinner = true

      var data = { "email": email }
      var url = this.$store.state.locals.apiUrl + '/deleteWhitelistUser'
      var config = {
        method: 'delete',
        url: url,
        headers: { 
          'api-key': this.$apikey, 
          'Content-Type': 'application/json'
        },
        data : data
      };

      axios(config)
      .then((response) => {
        this.getUserWhitelist()
        this.showSpinner = false

      })
      .catch((error) => {
        console.log(error);
        this.$store.state.error = error;
        this.$router.push('dashboard_error')
      });
    },

    parseWhitelist(data) {
      //console.log(this.results)

      var parsedResults = []

      for (let key in data) {
        let item = data[key];

        for (let param in item) {
          let value = item[param]

          // parse email
          if ( param == "email" ) {
            var email = value
          
          // parse created
          } else if ( param == "created" ) {
            if ( value == null ) {
              var created = "N/A"
            } else {
              var created = new Date(value).toLocaleString()
            }

          // parse used
          } else if ( param == "used" ) {
            if ( value == null ) {
              var used = "Not yet registered"
            } else {
              var used = new Date(value).toLocaleString()
            }
          }
        }
      
      //console.log(email, created, used)
      this.results.push({ 
        "email"   : email,
        "created" : created,
        "used"    : used 
      });
      }
    },

    confirmDelete(email) {
        //this.boxTwo = ''
        this.$bvModal.msgBoxConfirm('Are you sure you want to remove ' + email + ' from the whitelist?', {
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'danger',
          okTitle: 'YES',
          cancelTitle: 'NO',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true
        })
          .then(value => {
            if ( value == true ) {
              this.deleteWhitelistUser(email)
            }
            //console.log(value)
            //this.boxTwo = value
          })
          .catch(err => {
            // An error occurred
          })
    }

  }
}
</script>
